<template>
    <div class="bg-white py-5 px-xl-5 px-3 mb-3 rounded" id="create_new_own_course">
        <div class="container bg-gray">
            <div class="row">
                <div class="col-md-3 min-h-100">
                    <courses-stepper-component v-bind:activeStep="currentStep"></courses-stepper-component>
                </div>
                <div class="col-md-9 min-h-100 d-flex align-items-center justify-content-center" v-if="isLoading">
                    <div class="text-center">
                        <div class="spinner-grow text-grey" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 min-h-100" v-if="!isLoading">
                    <courses-not-started v-if="!currentStep" @startCreation="startCreation" ></courses-not-started>
                    <create-course-step-1
                        :stepData="courseData.step1Data || null"
                        @onCancel="clearStep"
                        @onNextStep="onStep2"
                        v-if="currentStep === 1"
                    ></create-course-step-1>
                    <create-course-step-2
                        :stepData="courseData.step2Data || null"
                        @onBack="onStep1"
                        @onSave="saveCourse"
                        v-if="currentStep === 2"
                    ></create-course-step-2>
                    <own-course-created
                        :course="courseData.step1Data"
                        v-if="currentStep === 3"
                        @onResetStep="resetCourseStep"
                    ></own-course-created>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["url_create_course"],
        data(){
            return {
                currentStep: null,
                courseData : {},
                isLoading: false
            }
        },
        methods: {
            startCreation(){
                this.currentStep = 1;
            },
            clearStep(){
                this.currentStep = null;
            },
            onStep1( data ){
                this.courseData = {
                    ...this.courseData,
                    step2Data: {...data}
                };
                this.currentStep = 1;
            },
            onStep2(data){
                this.courseData = {
                    ...this.courseData,
                    step1Data: {...data}
                };
                this.currentStep = 2;
            },
            saveCourse(stepData){
                this.courseData = { ...this.courseData, step2Data: stepData };
                this.isLoading = true;
                axios.post(this.url_create_course, this.createCourseObject())
                .then(res => {
                    const { uuid } = res.data;
                    if ( uuid ) {
                        const endPoint = `/dashboard/client/${uuid}/courses/update/sections`;
                        axios.post(endPoint, {
                            secciones: this.createCourseSectionsObject()
                        })
                        .then(resp => {
                            this.currentStep = 3;
                            this.isLoading = false;
                        })
                        .catch(console.log);
                    }
                })
                .catch(console.log);
            },
            createCourseObject(){
                return {
                    nombre_curso: this.courseData.step1Data.name,
                    descripcion_del_curso: this.courseData.step1Data.description,
                    nivel: this.courseData.step1Data.level,
                    estado_del_curso: this.courseData.step2Data.courseState,
                    cantidad_duracion_del_curso: this.calculateCourseDuration(),
                    tipo_duracion_del_curso: 'minutos',
                    maximo_estudiantes: 9999,
                    aprobacion: parseInt(this.calculateCourseApproval()),
                    tipo_evaluacion: "evaluate_lesson",
                    bloquear_finalizar: true,
                    bloquear_duracion: false,
                    lenguajes: "",
                    resena: "",
                };
            },
            createCourseSectionsObject(){
                const sections = [];
                const { modules = [], questionnaires = [] } = this.courseData.step2Data;

                modules.forEach(module => {
                    sections.push(this.handleModuleObject(module));
                });
                sections.push(this.handleQuestionnairesObject(questionnaires))

                return sections;
            },
            handleModuleObject(module){
                return {
                    "section_id": "",
                    "titulo_seccion": module.name,
                    "descripcion_seccion": module.description,
                    "items": module.lessons.map(lesson => ({
                        title: lesson.name,
                        description: lesson.description,
                        type: "lp_lesson",
                        duration: lesson.durationLength,
                        durationType: lesson.durationType
                    }))
                };
            },
            handleQuestionnairesObject(questionnaires){
                return {
                    "section_id": "",
                    "titulo_seccion": "Cuestionario",
                    "descripcion_seccion": "Sección de cuestionarios",
                    "items": questionnaires.map(questionnaire => {
                        return {
                            title: "",
                            description: "",
                            type: "lp_quiz",
                            cantidad_duracion_del_cuestionario: questionnaire.duracion,
                            tipo_duracion_del_cuestionario: questionnaire.tipoDuracion,
                            calificacion_aprobatoria: questionnaire.aprobacion,
                            retomar: questionnaire.repeticiones,
                            paginacion: 1,
                            revision_inmediata: false,
                            resena: true,
                            mostrar_respuesta_correcta: true,
                            preguntas: questionnaire.questions.map(question => {
                                return {
                                    title: question.question,
                                    description: question.description,
                                    points: "1",
                                    type: question.question_type,
                                    quiz_question_id: "",
                                    answer: question.answer,
                                    advice: question.advice,
                                    explanation: question.explanation,
                                    answers: question.answers.map(answer => ({
                                        option: answer.text,
                                        type: question.question_type === 'multi_choice' ? 'checkbox' : 'radio'
                                    }))
                                }
                            })
                        }
                    })
                }
            },
            calculateCourseDuration(){
                const { modules = [] } = this.courseData.step2Data;
                const totalMinutesDuration = modules.reduce((total, { lessons = [] }) => {
                    return total + lessons.reduce((lessonTotal, lesson) => {
                        return lessonTotal + this.convertToMinutes(lesson.durationLength, lesson.durationType);
                    }, 0);
                }, 0);
                // const courseDuration = this.calculateLargestCourseDuration(totalMinutesDuration);
                // console.log(`Duración total: ${courseDuration}`);
                return totalMinutesDuration;
            },
            calculateCourseApproval(){
                const totalApproval = this.courseData.step2Data.questionnaires.reduce((sum, questionnaire) => sum + parseInt(questionnaire.aprobacion), 0);
                return totalApproval / this.courseData.step2Data.questionnaires.length;
            },
            convertToMinutes(durationLength, durationType) {
                switch (durationType) {
                    case 'minutos':
                    return parseInt(durationLength);
                    case 'horas':
                    return parseInt(durationLength) * 60;
                    case 'dias':
                    return parseInt(durationLength) * 24 * 60;
                    case 'semanas':
                    return parseInt(durationLength) * 7 * 24 * 60;
                    default:
                    console.error('Duration type is not valid');
                    return 0; // Otra opción podría ser lanzar una excepción aquí
                }
            },

            calculateLargestCourseDuration(minutesDuration) {
                const units = [
                    { unit: 'semana', minutes: 7 * 24 * 60 },
                    { unit: 'día', minutes: 24 * 60 },
                    { unit: 'hora', minutes: 60 },
                    { unit: 'minuto', minutes: 1 }
                ];

                // const duracionFormateada = units.reduce((result, { unit, minutes }) => {
                //     const cantidad = Math.floor(minutesDuration / minutes);
                //     if (cantidad > 0) {
                //         result.push(`${cantidad} ${unit}${cantidad !== 1 ? 's' : ''}`);
                //         minutesDuration %= minutes;
                //     }
                // }, []);
                for (const { unit, minutes } of units) {
                    const cantidad = Math.floor(minutesDuration / minutes);
                    if (cantidad > 0) {
                        return `${cantidad} ${unit}${cantidad !== 1 ? 's' : ''}`;
                    }
                }

                return `${minutesDuration} minutos`;
            },

            resetCourseStep(){
                this.$emit('onRefreshData');
                this.courseData = {};
                this.currentStep = 0;
            }

        }
    }
</script>

<style>
    .bg-gray{
        background-color: #F8F8F8;
    }

    .min-h-100{
        min-height: 100%;
    }
</style>
